<template>
  <v-app>
    <!--  Side Bar  -->
    <v-navigation-drawer
      v-model="drawer"
      :permanent="$vuetify.breakpoint.mdAndUp"
      :mini-variant="$vuetify.breakpoint.mdAndUp ? mini : false"
      app
      color="aside"
      dark
      style="font-family: &quot;PT Sans Caption&quot;, sans-serif"
      class="fill-height"
    >
      <v-card flat color="aside" class="pa-2" width="100%">
        <div class="d-flex flex-column">
          <v-avatar class="align-self-center" size="70">
            <v-img
              alt="Logo"
              v-if="company.base64Logo"
              :src="`data:image/png;base64,${company.base64Logo}`"
              transition="scale-transition"
              @click="$router.push({ name: 'Summary' })"
            />
            <v-img v-else src="@/assets/logo.png" contain />
          </v-avatar>
        </div>

        <v-card-subtitle
          v-if="!mini"
          class="overline text-center pa-0 mt-3"
          style="line-height: 1rem"
        >
        </v-card-subtitle>
      </v-card>

      <v-divider></v-divider>

      <v-list v-if="!user['is_admin']">
        <div v-for="(item, i) in links" :key="i">
          <v-list-group
            v-if="item.sublinks.length > 0 || item.title === 'IBL'"
            v-model="item.active"
            active-class="font-weight-bolder white--text"
          >
            <template v-slot:activator>
              <v-list-item-icon>
                <v-icon>{{ item.icon }}</v-icon>
              </v-list-item-icon>
              <v-list-item-content>
                <v-list-item-title>{{ item.title }}</v-list-item-title>
              </v-list-item-content>
            </template>
            <v-list-item-group>
              <v-list-item
                v-for="(sub, s) in item.sublinks"
                :key="s"
                link
                :to="sub.to"
                :href="sub.link"
                :target="sub.link ? '_blank' : null"
                active-class="selectedItem"
              >
                <v-list-item-avatar v-if="!mini"> &nbsp; </v-list-item-avatar>
                <v-list-item-icon class="mr-2">
                  <v-icon v-if="!mini">{{ sub.icon }}</v-icon>

                  <v-badge
                    v-else
                    :content="sub.value || ''"
                    :value="sub.value"
                    color="success"
                    overlap
                    left
                  >
                    <v-icon>{{ sub.icon }}</v-icon>
                  </v-badge>
                </v-list-item-icon>
                <v-list-item-content>
                  <v-list-item-title>
                    {{ sub.title }}
                  </v-list-item-title>
                </v-list-item-content>
                <v-list-item-action v-if="sub.value">
                  <v-chip x-small color="success">
                    {{ sub.value }}
                  </v-chip>
                </v-list-item-action>
              </v-list-item>
            </v-list-item-group>
          </v-list-group>

          <v-list-item-group v-else>
            <v-list-item :to="item.to" active-class="selectedItem">
              <v-list-item-icon>
                <v-icon>{{ item.icon }}</v-icon>
              </v-list-item-icon>

              <v-list-item-content>
                <v-list-item-title>{{ item.title }}</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </v-list-item-group>
        </div>
      </v-list>

      <v-list v-if="user['is_admin']">
        <div v-for="(item, i) in adminLinks" :key="i">
          <v-list-group
            v-if="item.sublinks.length > 0"
            v-model="item.active"
            active-class="selectedItem"
          >
            <template v-slot:activator>
              <v-list-item-icon>
                <v-icon>{{ item.icon }}</v-icon>
              </v-list-item-icon>
              <v-list-item-content>
                <v-list-item-title>{{ item.title }}</v-list-item-title>
              </v-list-item-content>
            </template>
            <v-list-item-group>
              <v-list-item
                v-for="(sub, s) in item.sublinks"
                :key="s"
                link
                :to="sub.to"
                active-class="selectedItem"
              >
                <v-list-item-avatar v-if="!mini"> &nbsp; </v-list-item-avatar>
                <v-list-item-icon class="mr-2">
                  <v-icon v-if="!mini">{{ sub.icon }}</v-icon>

                  <v-badge
                    v-else
                    :content="sub.value || ''"
                    :value="sub.value"
                    color="success"
                    overlap
                    left
                  >
                    <v-icon>{{ sub.icon }}</v-icon>
                  </v-badge>
                </v-list-item-icon>
                <v-list-item-content>
                  <v-list-item-title>
                    {{ sub.title }}
                  </v-list-item-title>
                </v-list-item-content>
                <v-list-item-action v-if="sub.value">
                  <v-chip x-small color="success">
                    {{ sub.value }}
                  </v-chip>
                </v-list-item-action>
              </v-list-item>
            </v-list-item-group>
          </v-list-group>

          <v-list-item-group v-else>
            <v-list-item :to="item.to">
              <v-list-item-icon>
                <v-icon>{{ item.icon }}</v-icon>
              </v-list-item-icon>

              <v-list-item-content>
                <v-list-item-title>{{ item.title }}</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </v-list-item-group>
        </div>
      </v-list>

      <template v-slot:append>
        <div class="pa-2">
          <v-btn block text @click="logout">
            <v-icon>mdi-logout</v-icon> Logout
          </v-btn>
        </div>
      </template>
    </v-navigation-drawer>

    <!--  App Bar  -->
    <v-app-bar app elevation="0">
      <v-app-bar-nav-icon
        v-if="$vuetify.breakpoint.smAndDown"
        @click="drawer = !drawer"
      ></v-app-bar-nav-icon>

      <v-app-bar-nav-icon
        v-if="$vuetify.breakpoint.mdAndUp"
        @click="mini = !mini"
      ></v-app-bar-nav-icon>
      <!--      <DashboardBreadcrumb />-->
      <div v-if="$vuetify.breakpoint.mdAndUp" class="d-flex">
        <div class="d-flex">
          <v-icon color="primary" class="mr-1" size="18">
            mdi-email-outline
          </v-icon>
          <a
            href="mailto:examinations@kiseb.or.ke"
            class="links"
            target="_blank"
          >
            examinations@kiseb.or.ke
          </a>
          &nbsp;<span class="text--secondary">/</span>&nbsp;
          <a href="mailto:info@kiseb.or.ke" class="links" target="_new">
            info@kiseb.or.ke
          </a>
          <v-divider vertical class="mx-2 divider" />
        </div>
        <div class="d-flex primary--text">
          <v-icon color="primary" class="mr-1" size="18"
            >mdi-phone-outline</v-icon
          >
          <span>0726244828</span>
          &nbsp;<span class="text--secondary">/</span>&nbsp;
          <span>0111051840</span>
        </div>
      </div>
      <div v-else class="ml-n2">
        <v-tooltip top>
          <template v-slot:activator="{ on, attrs }">
            <div v-bind="attrs" v-on="on">
              <v-menu offset-y>
                <template v-slot:activator="{ on, attrs }">
                  <v-icon v-bind="attrs" v-on="on" color="primary" class="mr-1">
                    mdi-book-open-variant
                  </v-icon>
                </template>
                <v-list dense tile>
                  <v-list-item>
                    <v-list-item-title>
                      <v-icon left color="primary"> mdi-email-outline </v-icon>
                      <a
                        href="mailto:examinations@kiseb.or.ke"
                        class="links"
                        target="_blank"
                      >
                        examinations@kiseb.or.ke
                      </a>
                      &nbsp;<span class="text--secondary">/</span>&nbsp;
                      <a
                        href="mailto:info@kiseb.or.ke"
                        class="links"
                        target="_new"
                      >
                        info@kiseb.or.ke
                      </a>
                    </v-list-item-title> </v-list-item
                  ><v-list-item>
                    <v-divider />
                    <v-list-item-title>
                      <v-icon left color="primary"> mdi-phone-outline </v-icon>
                      <span class="primary--text">0726244828</span>
                      &nbsp;<span class="text--secondary">/</span>&nbsp;
                      <span class="primary--text">0111051840</span>
                    </v-list-item-title>
                  </v-list-item>
                </v-list>
              </v-menu>
            </div>
          </template>
          <span>Tooltip</span>
        </v-tooltip>
      </div>

      <div v-if="user.student !== null" class="registration_sm">
        <v-chip small label dense color="primary">
          {{ user.student !== null ? user.student["programmeStudentID"] : "" }}
        </v-chip>
      </div>
      <div v-if="user.student !== null" class="registration_sm mx-1">
        <v-chip small label dense color="primary">
          Balance(ksh): {{ balance | currencyFormat }}
        </v-chip>
      </div>
      <v-spacer class="spacer" sm="0" />
      <v-chip
        v-if="user.student !== null"
        class="registration_number pr-14"
        label
        dense
      >
        RegNo:
        {{ user.student !== null ? user.student["programmeStudentID"] : "" }}
      </v-chip>
      <v-chip
        v-if="user.student !== null"
        label
        dense
        class="registration_number mx-1"
        >Balance(ksh): {{ balance | currencyFormat }}</v-chip
      >
      <v-menu v-if="actions.length > 1" offset-y>
        <template v-slot:activator="{ on, attrs }">
          <v-btn v-bind="attrs" color="warning" outlined v-on="on">
            <v-icon left>mdi-alert</v-icon>
            {{ actions.length }} actions Needs your attention
          </v-btn>
        </template>
        <v-list dense tile>
          <v-list-item v-for="(action, i) in actions" :key="i" :to="action.to">
            <v-list-item-title>
              <v-icon left :color="action.color || 'warning'">
                {{ action.icon }}
              </v-icon>
              {{ action.name }}
            </v-list-item-title>
          </v-list-item>
        </v-list>
      </v-menu>

      <v-btn
        class="dark--mode"
        rounded
        icon
        @click="$vuetify.theme.dark = !$vuetify.theme.dark"
      >
        <v-icon>mdi-theme-light-dark</v-icon>
      </v-btn>
      <v-tooltip left>
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            v-bind="attrs"
            v-on="on"
            @click="
              $vuetify.breakpoint.mdAndUp
                ? (leftDrawer = !leftDrawer)
                : $router.push({ name: 'Notifications' })
            "
            rounded
            icon
            :class="$vuetify.breakpoint.mobile ? 'ml-n4 mr-n3' : ''"
          >
            <v-badge :content="1" :value="1" color="red" overlap dot>
              <v-icon>mdi-newspaper</v-icon>
            </v-badge>
          </v-btn>
        </template>
        <span>Notice Board</span>
      </v-tooltip>
      <!--BEGIN profile-->
      <AccountProfileDropdown :menus="menus" />
      <!--END profile dropdown-->
    </v-app-bar>

    <v-divider />

    <v-main class="background">
      <v-row class="fill-height" :no-gutters="leftDrawer">
        <v-col :cols="leftDrawer ? '9' : '12'">
          <router-view class="py-5" />
        </v-col>
        <v-col :cols="leftDrawer ? '3' : '0'">
          <v-card v-if="leftDrawer" tile elevation="0" class="fill-height">
            <v-card-title class="overline">
              Notice Board

              <v-spacer />

              <v-btn small icon @click="leftDrawer = !leftDrawer">
                <v-icon> mdi-close </v-icon>
              </v-btn>
            </v-card-title>
            <v-divider />

            <info-section />
          </v-card>
        </v-col>
      </v-row>
    </v-main>

    <spinner />

    <ConfirmationComponent />

    <checkout />

    <FooterComponent />
  </v-app>
</template>

<script>
import FooterComponent from "../../../components/FooterComponent";
import Spinner from "../../../plugins/loader/views/Spinner";
import { AuthService } from "../../auth";
import InfoSection from "../../../components/InfoSection";
import AccountProfileDropdown from "../components/DashboardProfileDropdown";

export default {
  name: "DashboardLayout",
  components: {
    AccountProfileDropdown,
    InfoSection,
    Spinner,
    FooterComponent,
  },
  data: () => ({
    drawer: null,
    leftDrawer: false,
    mini: false,
    selectedItem: 0,
    fav: true,
    menu: false,
    message: false,
    hints: true,
    settingsFormData: {
      minor_settings: {
        ibl_link: [],
        selected_ibl_links: [],
        dashboard_links: [],
      },
      site_colors: [],
      site_installed_packages: [],
    },
  }),

  beforeRouteEnter(to, from, next) {
    next((v) => {
      v.$store.dispatch("Landing/getCompanyInfo");
      v.$store.dispatch("Dashboard/getSettings");
      v.$store.dispatch("Checklist/getChecklist", {
        category:
          AuthService.user.student !== null
            ? AuthService.user.student.programmeStudentID.split("/")[0] ===
                "CPSPK" ||
              AuthService.user.student.programmeStudentID.split("/")[0] ===
                "CPSP"
              ? "CPSP-K"
              : "APS-K"
            : "APS-K",
        type: "Profile",
      });
      v.$store.dispatch("Dashboard/getStudentProgrammes");
      v.$store.dispatch("Dashboard/getIntakePeriods");
      v.$store.dispatch("Dashboard/getBalance", AuthService.user.profile_id);
    });
  },

  computed: {
    balance() {
      return this.$store.getters["Dashboard/balance"];
    },
    bioData() {
      return AuthService.user.profile;
    },
    user() {
      return AuthService.user;
    },
    company() {
      return this.$store.getters["Landing/company"];
    },
    settings() {
      return this.$store.getters["Dashboard/settings"];
    },
    links() {
      const links = this.$store.getters["Dashboard/links"];

      const ibl = links.find((link) => link.title === "IBL");
      ibl
        ? (ibl.sublinks =
            this.settingsFormData.minor_settings.selected_ibl_links)
        : links.push({
            disabled: false,
            icon: "mdi-book-open-page-variant",
            order: 1,
            title: "IBL",
            to: "/exams/ibl",
            sublinks: this.settingsFormData.minor_settings.selected_ibl_links,
          });

      return links
        .filter((item) => !item.disabled && item.title !== "Administration")
        .map((link) => {
          link.sublinks = link.sublinks || [];
          return link;
        });
    },
    adminLinks() {
      return this.$store.getters["Dashboard/links"]
        .filter((item) => !item.disabled && item.title === "Administration")
        .map((link) => {
          link.sublinks = link.sublinks || [];
          return link;
        });
    },
    actions() {
      return this.$store.getters["Dashboard/actions"];
    },
    checkList() {
      return this.$store.getters["Checklist/checklist"].filter(
        (item) => !item.pass,
      );
    },
    checklistAction() {
      return [
        {
          name:
            this.checkList === 0 ? "Profile Complete" : "Incomplete Profile",
          icon: this.checkList === 0 ? "mdi-check" : "mdi-alert",
          to: { name: "Check List", params: { type: "Profile" } },
        },
      ];
    },
    menus() {
      return this.$store.getters["Dashboard/menus"];
    },
  },
  methods: {
    logout() {
      AuthService.logout();
    },
  },
  watch: {
    settings: {
      handler: async function (val) {
        if (val) {
          this.settingsFormData.minor_settings =
            val && val.minor_settings
              ? JSON.parse(val.minor_settings)
              : this.settingsFormData.minor_settings;
          this.settingsFormData.site_colors =
            val && val.site_colors
              ? JSON.parse(val.site_colors)
              : this.objectToArray(this.$vuetify.theme.themes.light);
          this.settingsFormData.site_installed_packages =
            val && val.site_installed_packages
              ? JSON.parse(val.site_installed_packages)
              : [];
        }
      },
      deep: true,
    },
  },
};
</script>

<style>
@import url("../styles.css");
</style>
